<script setup lang="ts">
interface TimelineDotProps {
  size?: "md" | "lg";
}

const props = withDefaults(defineProps<TimelineDotProps>(), {
  size: "md",
});
</script>

<template>
  <div
    :class="['timeline-dot', `timeline-dot-${props.size}`]"
    aria-hidden="true"
  ></div>
</template>

<style scoped>
.timeline-dot {
  position: absolute;
  left: 50%;
  top: 3rem;
  border-radius: 9999px;
  transform: translateX(-50%);
  background-color: var(--color-secondary-500);
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1);
  box-shadow: 0 0 0 4px white;
  z-index: 10;
  transition: all 0.3s;
}

@media (max-width: 767px) {
  .timeline-dot {
    top: -0.5rem;
  }
}

.dark .timeline-dot {
  box-shadow: 0 0 0 4px var(--color-primary-950);
}

/* Size: md (default) */
.timeline-dot-md {
  width: 1rem;
  height: 1rem;
}

/* Size: lg (first/featured) */
.timeline-dot-lg {
  width: 1.25rem;
  height: 1.25rem;
  background-image: linear-gradient(
    to bottom right,
    var(--color-secondary-400),
    var(--color-secondary-600)
  );
}

/* Hover effects - parent component should have .timeline-row class */
.timeline-row:hover .timeline-dot {
  box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1);
  background-image: linear-gradient(
    to bottom right,
    var(--color-secondary-400),
    var(--color-secondary-600)
  );
}

@media (min-width: 767px) {
  .timeline-row:hover .timeline-dot {
    transform: translateX(-50%) scale(1.25);
  }
}
</style>
